import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen, FilterBox} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Display,Button,Line,Card,DataGrid,IDataGridLayout} from 'ktm-ui';

interface IDistros {
    Id:string;
    Name:string;
    MailingCity:string;
    MailingProv:string;
};

export default KTMScreen({name:"planadmin.lookups.distro"}, class extends React.Component<{keyword?:string,eventValue?:string}> {

    data:{
        Distros:IDistros;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@Distros";
        await KTMApi.start(screen,{
            "@keyword":this.props.keyword
        });
        screen.onEnterKey = this.search;
        screen.title = "Distro lookup";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout  dialogSize="medium" dialogHeight="medium" padding="none">
                {draw(this.header)}
                {draw(this.search_panel)}
                {draw(this.default_view)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Distro lookup">
            </Dialog.Header>
        );
    }

    search_panel({field,draw,action}:RenderEvent){
        return (
            <Card>
                <Line>
                    <FilterBox field={field("@keyword")} />
                    <Button action={action(this.search)} label="Search" style="primary"/>
                </Line>
            </Card>
        );
    }

    default_view({field,draw,action,collection}:RenderEvent){
        let actions = null;
        let layout:IDataGridLayout = {
            columns:[
                {name:"Name",label:"Name",type:"character",width:380},
                {name:"MailingCity",label:"Mailing City",type:"character",width:150},
                {name:"MailingProv",label:"Mailing Prov",type:"character",width:100},
            ],
            sort:[{name:"Name"}]
        };
        return (
            <DataGrid collection={collection("@Distros")} layout={layout} actions={actions} onRowClick={action(this.on_row_click)}/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
            </Dialog.Footer>
        );
    }

    async search({screen}:ActionEvent){
        await KTMApi.action(screen,"search",{
            "@keyword":screen.getFilter("@keyword")
        });
    }

    async on_row_click({screen}:ActionEvent){
        screen.close({continue:true,value:screen.getValue("Id"),label:screen.getValue("name")});
    }

});
